/**
 * Main shell: sticky Header on top, sticky Sidebar on the left, scrollable
 * Main in the middle. Only rendered for authenticated users; the router
 * wraps this in <RequireAuth> before mounting.
 */
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

export function AppLayout() {
  return (
    <div className="min-h-screen bg-expo-light">
      <Header />
      <div className="flex h-[calc(100vh-108px)]">
        <Sidebar />
        <main className="flex-1 min-w-0 bg-expo-light overflow-y-auto scrollbar-thin">
          <div className="mx-auto max-w-7xl p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
